import { PlayerNumberMap } from '../../jscaip/PlayerMap';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
export class SiamState extends GameStateWithTable {
    countCurrentPlayerPawn() {
        const currentPlayer = this.getCurrentPlayer();
        return this.countPlayersPawn().get(currentPlayer);
    }
    countPlayersPawn() {
        const counts = PlayerNumberMap.of(0, 0);
        for (const coordAndContent of this.getCoordsAndContents()) {
            if (coordAndContent.content.getOwner().isPlayer()) {
                counts.add(coordAndContent.content.getOwner(), 1);
            }
        }
        return counts;
    }
}
